import { UpsertClub } from '@/components/clubs/upsert-club/UpsertClub';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Edit, UserCheck } from 'lucide-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const CreateClub: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();  
  const club = location.state?.club;
  const isReadOnly = location.state?.isReadOnly || false;

  return (
    <>
      <div className="mb-6 gap-2 flex items-center">
        <div>
          <Button
            type="button"
            variant="ghost"
            onClick={() => navigate('/clubs')}
            className="flex items-center gap-2"
          >
            <ChevronLeft size={16} />
          </Button>
        </div>
        <div className="flex items-center gap-3">
          {isReadOnly ? (
            <UserCheck size={28} className="text-blue-600" />
          ) : (
            <Edit size={28} className="text-green-600" />
          )}
          <div>
            <h2 className="text-2xl font-bold">
              {club 
                ? (isReadOnly ? 'Detalles Club' : 'Editar Club')
                : 'Nuevo Club'
              }
            </h2>
            {isReadOnly && (
              <p className="text-sm text-gray-600 mt-1">
                Tienes permisos de manager en este club
              </p>
            )}
          </div>
        </div>
      </div>
      <UpsertClub club={club} isReadOnly={isReadOnly} />
    </>
  );
};